import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { RiBracketsLine } from "@remixicon/react";
import SchemaConfigTable from "./SchemaConfigTable";

interface DisplayDatasetSchemaModalButtonProps_T {
  datasetId: string;
  datasetName: string;
  datasetType: "sample" | "delivery";
}

const DisplayDatasetSchemaModalButton: React.FC<
  DisplayDatasetSchemaModalButtonProps_T
> = ({ datasetId, datasetName, datasetType }) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleClickOpenModal = () => {
    setDialogOpen(true);
  };

  const handleCloseModal = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <IconButton onClick={handleClickOpenModal}>
        <RiBracketsLine />
      </IconButton>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseModal}
        maxWidth={false}
        fullWidth
        PaperProps={{
          style: {
            width: "80%",
            height: "80%",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle>{`${datasetName} Schema Configuration`}</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "calc(100% - 64px)",
            padding: "16px",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              overflow: "hidden",
              padding: "16px",
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                overflow: "auto",
              }}
            >
              <SchemaConfigTable
                datasetId={datasetId}
                datasetType={datasetType}
                customHeight="100%"
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplayDatasetSchemaModalButton;
